__turbopack_context__.v({
  "cardContainer": "IndicationCard-module-scss-module__DmNP0G__cardContainer",
  "container": "IndicationCard-module-scss-module__DmNP0G__container",
  "containerWarehouse": "IndicationCard-module-scss-module__DmNP0G__containerWarehouse",
  "description": "IndicationCard-module-scss-module__DmNP0G__description",
  "descriptionContainer": "IndicationCard-module-scss-module__DmNP0G__descriptionContainer",
  "hovered": "IndicationCard-module-scss-module__DmNP0G__hovered",
  "indicator": "IndicationCard-module-scss-module__DmNP0G__indicator",
  "mainContent": "IndicationCard-module-scss-module__DmNP0G__mainContent",
  "title": "IndicationCard-module-scss-module__DmNP0G__title",
});
